import { render, staticRenderFns } from "./PageEditor.vue?vue&type=template&id=e2d00c66&scoped=true&"
import script from "./PageEditor.vue?vue&type=script&lang=js&"
export * from "./PageEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d00c66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2d00c66')) {
      api.createRecord('e2d00c66', component.options)
    } else {
      api.reload('e2d00c66', component.options)
    }
    module.hot.accept("./PageEditor.vue?vue&type=template&id=e2d00c66&scoped=true&", function () {
      api.rerender('e2d00c66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/page/PageEditor.vue"
export default component.exports